<script>
    import classnames from 'classnames';

    import {showProductModal} from '@js/actions/basketActions';

    import I18n from '@js/modules/translations';

    import {
        MapLayers
    } from '@js/components/modules/constants';

    import {clickOutside} from '@js/components/themes/actions/clickOutside';

    import MapTileService from '@js/modules/maps/mapTileService';

    import explorerIcon from '@/images/products/explorer_icon.png';

    import ignStyle from '@/images/maps/styles/ign.png';
    import mpStyle from '@/images/maps/styles/map_planner.png';
    import outdoorStyle from '@/images/maps/styles/map_planner_outdoor.png';
    import mapboxOutdoorStyle from '@/images/maps/styles/mapbox_outdoor.png';
    import satelliteStyle from '@/images/maps/styles/mapbox_satellite.png';
    import streetStyle from '@/images/maps/styles/mapbox_street.png';
    import osmStyle from '@/images/maps/styles/open_street_map.png';

    const {
        mapLayersAvailable,
        isFullscreen = false,
        onMapStyleChange
    } = $props();

    let currentMapStyle = $state(MapTileService.getTileService());
    let isMapStyleOpen = $state(false);

    const MapStyleIcons = {
        map_planner: mpStyle,
        map_planner_outdoor: outdoorStyle,
        mapbox_outdoor: mapboxOutdoorStyle,
        mapbox_street: streetStyle,
        mapbox_satellite: satelliteStyle,
        open_street_map: osmStyle,
        ign: ignStyle
    };

    const availableMapStyles = Object.values(MapLayers)
        .filter((mapStyle) => mapLayersAvailable.includes(mapStyle));
    const unavailableMapStyles = Object.values(MapLayers)
        .filter((mapStyle) => !mapLayersAvailable.includes(mapStyle));

    const handleMapLayersOutsideClick = () => {
        if (!isMapStyleOpen) {
            return;
        }

        isMapStyleOpen = false;
    };

    const _handleMapStyleButtonClick = () => {
        isMapStyleOpen = !isMapStyleOpen;
    };

    const _handleMapStyleSelected = (mapStyle) => {
        isMapStyleOpen = !isMapStyleOpen;

        currentMapStyle = mapStyle;

        onMapStyleChange(mapStyle);
    };

    const _handleUnavailableMapStyle = () => {
        showProductModal('map_style');
    };
</script>

<div id="map-controls-container"
     class="map-controls-container"
     class:map-controls-fullscreen={isFullscreen}>
    <div class={classnames('controls-container', {'map-style-open': isMapStyleOpen})}>
        {#if isMapStyleOpen}
            <div {@attach clickOutside(handleMapLayersOutsideClick, 'map-layers-button')}
                 class="map-style-modal">
                <div class="map-style-modal-content">
                    <h3 class="map-style-modal-title">
                        {I18n.t('js.maps.toolbar.style_available')}
                    </h3>

                    <div class="map-style-options">
                        {#each availableMapStyles as mapLayerName (mapLayerName)}
                            <button class={classnames('map-style-option', `map-style-${mapLayerName}`)}
                                    onclick={() => _handleMapStyleSelected(mapLayerName)}>
                                <img class={classnames('map-style-option-img', {
                                     'map-style-selected': mapLayerName === currentMapStyle
                                 })}
                                     src={MapStyleIcons[mapLayerName]}
                                     alt={`${mapLayerName} Style`}
                                     loading="lazy"/>
                                {I18n.t(`js.maps.toolbar.styles.${mapLayerName}`)}
                            </button>
                        {/each}
                    </div>
                </div>

                {#if unavailableMapStyles.length > 0}
                    <div class="map-style-modal-content">
                        <h3 class="map-style-modal-title">
                            {I18n.t('js.maps.toolbar.style_unavailable')}
                            <img class="map-style-limited-only"
                                 src={explorerIcon}
                                 alt="MapPlanner Explorer icon"/>
                        </h3>

                        <div class="map-style-options">
                            {#each unavailableMapStyles as mapLayerName (mapLayerName)}
                                <button class={classnames('map-style-option', 'map-style-disabled', `map-style-${mapLayerName}`)}
                                        title={I18n.t('js.maps.toolbar.style_tooltip')}
                                        onclick={_handleUnavailableMapStyle}>
                                    <img class="map-style-option-img"
                                         src={MapStyleIcons[mapLayerName]}
                                         alt={`${mapLayerName} Style`}
                                         loading="lazy"/>
                                    {I18n.t(`js.maps.toolbar.styles.${mapLayerName}`)}
                                </button>
                            {/each}
                        </div>
                    </div>
                {/if}

                <button class="map-style-close"
                        aria-label="Close"
                        onclick={_handleMapStyleButtonClick}>
                    <svg class="w-3 h-3"
                         aria-hidden="true"
                         xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                </button>
            </div>
        {:else}
            <button id="map-layers-button"
                    class="map-control-button map-style-chooser"
                    style="background-image: url('{MapStyleIcons[currentMapStyle]}')"
                    onclick={_handleMapStyleButtonClick}>
                {I18n.t(`js.maps.toolbar.styles.${currentMapStyle}`)}
            </button>
        {/if}
    </div>
</div>
